module.exports = __webpack_public_path__ + "img/acting__tips.37f2fbaf.svg";